<div class="pt-4">
  <soft-numpad
    class=""
    [(value)]="value"
    [quickNumbers]="quickNumbers()"
    [unit]="unit()"
    (save)="save($event)"
    [heightPx]="height()"
    [min]="min()"
    [max]="max()"
    [floatingPoints]="floatingPoints()"
    [selectExistingInput]="selectExistingInput()"
  ></soft-numpad>
</div>
